import {
  Checkbox,
  DateRangePicker,
  FilterToolbar,
  type DateRangePickerValue,
} from '@roger/ui-components';

export interface VisitCompletionByClinicianReportHeaderProps {
  searchTerm: string;
  onSearchTermChange: (value: string) => void;
  dateRange: DateRangePickerValue;
  onDateRangeChange: (value: DateRangePickerValue) => void;
  showBreakdown: boolean;
  onShowBreakdownChange: (value: boolean) => void;
  hideNeverLoggedIn: boolean;
  onHideNeverLoggedInChange: (value: boolean) => void;
}

const VisitCompletionByClinicianReportHeader = ({
  searchTerm,
  onSearchTermChange,
  dateRange,
  onDateRangeChange,
  showBreakdown,
  onShowBreakdownChange,
  hideNeverLoggedIn,
  onHideNeverLoggedInChange,
}: VisitCompletionByClinicianReportHeaderProps) => (
  <>
    <div className='text-sm text-[#735bd6] mb-2 -mt-2'>
      All data is from 08/25/2025 onward
    </div>

    <FilterToolbar
      search={{
        value: searchTerm,
        onChange: onSearchTermChange,
        label: 'Search',
        placeholder: 'Search by clinician name...',
        'aria-label': 'Search by clinician name',
      }}
    >
      <DateRangePicker
        className='w-full md:w-80'
        value={dateRange}
        onChange={onDateRangeChange}
        showClearButton
      />

      <div className='flex flex-col pt-6'>
        <div className='flex items-center gap-2'>
          <label className='flex items-center space-x-2'>
            <Checkbox
              checked={showBreakdown}
              onCheckedChange={checked => {
                const v = !!checked;
                onShowBreakdownChange(v);
                localStorage.setItem(
                  'adoptionReport_showBreakdown',
                  JSON.stringify(v)
                );
              }}
            />
            <span className='text-sm'>Display visit type breakdown</span>
          </label>
        </div>

        <div className='flex items-center gap-2'>
          <label className='flex items-center space-x-2'>
            <Checkbox
              checked={hideNeverLoggedIn}
              onCheckedChange={checked => {
                const v = !!checked;
                onHideNeverLoggedInChange(v);
                localStorage.setItem(
                  'adoptionReport_hideNeverLoggedIn',
                  JSON.stringify(v)
                );
              }}
            />
            <span className='text-sm'>Hide users who never logged in</span>
          </label>
        </div>
      </div>
    </FilterToolbar>
  </>
);

export default VisitCompletionByClinicianReportHeader;
